module.exports = __webpack_public_path__ + "img/Group 265.cd955d5e.svg";